import React from 'react';
import color from 'src/styles/themes/color';

type Props = {
  w?: number;
  h?: number;
  fill?: string;
  className?: string;
  onClick?: () => void;
};

const IconMultipleQuotes: React.FC<Props> = ({
  w = 18,
  h = 18,
  fill = color.grey_3,
  className,
  onClick,
}) => {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M15.4286 0H0.642857C0.287277 0 0 0.287277 0 0.642857V15.4286C0 15.7842 0.287277 16.0714 0.642857 16.0714H15.4286C15.7842 16.0714 16.0714 15.7842 16.0714 15.4286V0.642857C16.0714 0.287277 15.7842 0 15.4286 0ZM14.625 14.625H1.44643V1.44643H14.625V14.625ZM7.63393 5.78571H11.3304C11.4188 5.78571 11.4911 5.71339 11.4911 5.625V4.66071C11.4911 4.57232 11.4188 4.5 11.3304 4.5H7.63393C7.54554 4.5 7.47322 4.57232 7.47322 4.66071V5.625C7.47322 5.71339 7.54554 5.78571 7.63393 5.78571ZM7.63393 8.67857H11.3304C11.4188 8.67857 11.4911 8.60625 11.4911 8.51786V7.55357C11.4911 7.46518 11.4188 7.39286 11.3304 7.39286H7.63393C7.54554 7.39286 7.47322 7.46518 7.47322 7.55357V8.51786C7.47322 8.60625 7.54554 8.67857 7.63393 8.67857ZM7.63393 11.5714H11.3304C11.4188 11.5714 11.4911 11.4991 11.4911 11.4107V10.4464C11.4911 10.358 11.4188 10.2857 11.3304 10.2857H7.63393C7.54554 10.2857 7.47322 10.358 7.47322 10.4464V11.4107C7.47322 11.4991 7.54554 11.5714 7.63393 11.5714ZM4.58036 5.14286C4.58036 5.35598 4.66502 5.56037 4.81572 5.71107C4.96642 5.86177 5.17081 5.94643 5.38393 5.94643C5.59705 5.94643 5.80144 5.86177 5.95214 5.71107C6.10284 5.56037 6.1875 5.35598 6.1875 5.14286C6.1875 4.92974 6.10284 4.72535 5.95214 4.57465C5.80144 4.42395 5.59705 4.33929 5.38393 4.33929C5.17081 4.33929 4.96642 4.42395 4.81572 4.57465C4.66502 4.72535 4.58036 4.92974 4.58036 5.14286ZM4.58036 8.03572C4.58036 8.24884 4.66502 8.45323 4.81572 8.60393C4.96642 8.75463 5.17081 8.83929 5.38393 8.83929C5.59705 8.83929 5.80144 8.75463 5.95214 8.60393C6.10284 8.45323 6.1875 8.24884 6.1875 8.03572C6.1875 7.82259 6.10284 7.6182 5.95214 7.4675C5.80144 7.31681 5.59705 7.23214 5.38393 7.23214C5.17081 7.23214 4.96642 7.31681 4.81572 7.4675C4.66502 7.6182 4.58036 7.82259 4.58036 8.03572ZM4.58036 10.9286C4.58036 11.1417 4.66502 11.3461 4.81572 11.4968C4.96642 11.6475 5.17081 11.7321 5.38393 11.7321C5.59705 11.7321 5.80144 11.6475 5.95214 11.4968C6.10284 11.3461 6.1875 11.1417 6.1875 10.9286C6.1875 10.7155 6.10284 10.5111 5.95214 10.3604C5.80144 10.2097 5.59705 10.125 5.38393 10.125C5.17081 10.125 4.96642 10.2097 4.81572 10.3604C4.66502 10.5111 4.58036 10.7155 4.58036 10.9286Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconMultipleQuotes;
